// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"780":"360e8fd41a374b3a5946","972":"7df170f20e8102dae348"}[chunkId] + ".bundle.js";
};